<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <div class="d-inline" v-on="on">
                <RichTextEditorToolbarVue
                    :id="toolbarId"
                    :include-link="includeLink"
                    :include-text-size="includeTextSize"
                />
            </div>
        </template>
        <span>{{ $t("Format text") }}</span>
    </v-tooltip>
</template>

<script>

import RichTextEditorToolbarVue from "../../../components/RichTextEditor/RichTextEditorToolbar.vue";

export default {
    name: "RichTextEditorToolbarWrapper",
    components: {RichTextEditorToolbarVue},
    props: {
        toolbarId: {
            type: String,
            default: "email-signature-toolbar"
        },
        includeLink: {
            type: Boolean,
            default: false,
        },
        includeTextSize: {
            type: Boolean,
            default: false
        }
    }

}
</script>


<style scoped lang="scss">

</style>